import { Component, computed, AfterViewInit } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

import { distinctUntilChanged, takeUntil } from 'rxjs';
import { injectDestroy } from 'ngxtension/inject-destroy';
import { FuseCardComponent } from '../../../../../../../../@fuse/components/card';
import {
  calculateHours,
  calculateHoursPerDay,
  calculateHoursPerHourRateType,
} from '../../time-registration/time-registration-totals';

@Component({
  selector: 'app-time-registration-wrapper',
  template: `
    <fuse-card class="p-5 flex flex-col w-full gap-4 border-0 shadow-none">
      <div class="flex flex-col md:flex-row gap-4">
        <!-- Client info -->
        <div class="flex-0 w-full md:w-60 flex flex-col">
          @for (field of clientInfoFields(); track field) {
            <formly-field [field]="field"></formly-field>
          }
        </div>

        <div class="flex flex-col w-full ">
          <!-- Week hours -->
          <div class="flex flex-row w-full">
            <div class="flex flex-1 gap-4 flex-col lg:flex-row">
              @for (field of weekFields(); track field) {
                <formly-field class="flex-1" [field]="field"></formly-field>
              }
            </div>
            @if (multipleHour()) {
              <div class="flex-0 w-20 lg:flex hidden"></div>
            }
          </div>
          <div class="grid ">
            @for (field of otherFields(); track field) {
              <formly-field [field]="field"></formly-field>
            }
            <!-- Actions -->
          </div>
        </div>
      </div>
    </fuse-card>
  `,
  // Lives on the wrapper (not its host page) so the hour rows render the same on the
  // employee week view and on the generic details page of the approval module.
  styles: `
    :host ::ng-deep .hide-label formly-repeat-section > div {
      margin: 0 !important;
      .repeater-item {
        margin-bottom: 0 !important;
      }
    }
  `,
  imports: [FormlyModule, FuseCardComponent],
})
export class TimeRegistrationWrapper extends FieldWrapper implements AfterViewInit {
  daysFields = ['hours'];
  clientFields = ['status', 'user', 'company', 'location', 'project', 'activity', 'date'];

  clientInfoFields = computed(() => {
    return this.field.fieldGroup?.filter(f => this.clientFields.includes(f.key as string)) || [];
  });

  weekFields = computed(() => {
    return this.field.fieldGroup?.filter(f => this.daysFields.includes(f.key as string)) || [];
  });

  otherFields = computed(() => {
    return (
      this.field.fieldGroup?.filter(f => ![...this.daysFields, ...this.clientFields].includes(f.key as string)) || []
    );
  });

  multipleHour = computed(() => {
    return this.model?.hours?.length > 1;
  });

  private destroy$ = injectDestroy();

  constructor() {
    super();
  }

  ngAfterViewInit() {
    requestAnimationFrame(() => {
      this.field.form.valueChanges.pipe(takeUntil(this.destroy$), distinctUntilChanged()).subscribe(value => {
        value = this.field.formControl.getRawValue();
        if (
          this.field.formControl.value['total-hours'] != calculateHours(value) &&
          this.field.formControl.value['hours-per-day'] != calculateHoursPerDay(value) &&
          this.field.formControl.value['hours-per-hourrate-type'] !=
            calculateHoursPerHourRateType(value)
        ) {
          this.field.formControl
            .get('total-hours')
            ?.patchValue(calculateHours(value), { emitEvent: false });
          this.field.formControl
            .get('hours-per-day')
            ?.patchValue(calculateHoursPerDay(value), { emitEvent: false });
          this.field.formControl
            .get('hours-per-hourrate-type')
            ?.patchValue(calculateHoursPerHourRateType(value), { emitEvent: false });
        }
      });
    });
  }
}
